import * as React from "react";
import { Icon } from "./LandingIcons";

interface Tier {
  name: string;
  monthly: number;
  yearly: number;
  perSeat?: boolean;
  desc: string;
  cta: string;
  rec: boolean;
  features: string[];
  locked: string[];
}

const TIERS: Tier[] = [
  {
    name: "Free",
    monthly: 0,
    yearly: 0,
    desc: "Try the assistant. Memory across devices. No credit card.",
    cta: "Start free",
    rec: false,
    features: [
      "50 voice turns / month",
      "Push-to-talk activation",
      "Memory across devices",
      "Time, recall, and remember tools",
      "Community Discord",
    ],
    locked: [
      "Wake-word ('Hey Omni')",
      "Web search + delegated tasks",
      "Background sub-agents",
    ],
  },
  {
    name: "Pro",
    monthly: 19,
    yearly: 15,
    desc: "Everything that makes Omni feel like the real Jarvis.",
    cta: "Upgrade to Pro",
    rec: true,
    features: [
      "1,000 voice turns / month",
      "Wake-word activation ('Hey Omni' / 'Jarvis' / 'Computer')",
      "All built-in tools incl. delegate_task + search_web",
      "Background sub-agents + Omni Pane widgets",
      "Priority queue (Sonnet 4.6, no Haiku fallback)",
      "Persistent memory · cross-device sync",
    ],
    locked: [],
  },
];

export function PricingGrid() {
  const [annual, setAnnual] = React.useState<boolean>(true);

  return (
    <section id="pricing" className="section">
      <div className="container">
        <div className="section__head section__head--center">
          <div className="eyebrow eyebrow--accent">Pricing</div>
          <h2 className="section__title">Honest pricing. No usage roulette.</h2>
          <p className="section__sub">
            Two plans, both honest. Free forever for individuals; Pro at
            nineteen for everyone who lives in the voice loop. Annual
            saves twenty percent. Self-host the open-source runtime any
            time you want.
          </p>
          <div className="billing" style={{ marginTop: 28 }}>
            <button
              className={!annual ? "active" : ""}
              onClick={() => setAnnual(false)}
            >
              Monthly
            </button>
            <button
              className={annual ? "active" : ""}
              onClick={() => setAnnual(true)}
            >
              Annual <span className="save">−20%</span>
            </button>
          </div>
        </div>

        <div className="pricing">
          {TIERS.map((t) => {
            const price = annual ? t.yearly : t.monthly;
            return (
              <div
                key={t.name}
                className={`price ${t.rec ? "price--rec" : ""}`}
              >
                {t.rec && <span className="price__rec-tag">Most popular</span>}
                <div className="price__name">{t.name}</div>
                <div className="price__amount">
                  <span className="big">
                    {price === 0 ? "$0" : `$${price}`}
                  </span>
                  <span className="per">
                    /{t.perSeat ? "seat / mo" : "month"}
                    {annual && price > 0 ? " · billed yearly" : ""}
                  </span>
                </div>
                <div className="price__desc">{t.desc}</div>
                <ul className="price__features">
                  {t.features.map((f) => (
                    <li key={f}>
                      <Icon name="check" size={14} /> {f}
                    </li>
                  ))}
                  {t.locked.map((f) => (
                    <li key={f} className="dim">
                      <Icon name="lock" size={12} /> {f}
                    </li>
                  ))}
                </ul>
                <a
                  href="#"
                  className={`btn ${t.rec ? "btn--accent" : "btn--ghost"}`}
                  style={{ width: "100%" }}
                >
                  {t.cta}
                </a>
              </div>
            );
          })}
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: 36,
            fontSize: 13,
            color: "var(--fg-faint)",
          }}
          className="mono"
        >
          All plans include unlimited memory writes · open-source SDK ·
          MIT-licensed runtime
        </div>
      </div>
    </section>
  );
}
